import { constants as config } from '@config';

import { instance as CompanyFactory } from '../../../factory/company';
import BaseView from '../components/common/common-component';

import RedfinView from './redfin';
import template from './redfin-template.hbs';

module.exports = BaseView.extend({
  type: 'redfin',

  initialize: function () {
    BaseView.prototype.initialize.call(this);
    this.addOrderPrintLink();
    const companyPromise = CompanyFactory.getCompany();
    const designPromise = CompanyFactory.get(['designs', INKIVE.C.BOOK.encodedId]);

    $.when(companyPromise, designPromise).then((c, d) => this.initCallback(c, d));
  },

  initCallback: function (c, d) {
    this.tool = INKIVE.Tool.getInstance();
    this.companyId = c.id;
    this.searchTerm = this.getSearchTerm(d.metadata);
    if (this.searchTerm) {
      document.querySelector('[href="#tabRedfin"]').parentNode.style.display = 'flex';
    }
  },

  getSearchTerm: function (metadata) {
    const {
      search_term: searchTerm,
      search_params: searchParams
    } = metadata || {};

    return getSearchTermFromSearchParams() || (searchTerm && searchTerm.encrypted_deal_id);

    function getSearchTermFromSearchParams () {
      if (!searchParams || !Array.isArray(searchParams) || !searchParams.length) return;

      return searchParams.reduce((acc, next) => {
        if (acc) return acc;

        return next.search_term;
      }, undefined);
    }
  },

  isAlreadyThere: function () {
    return !!this.el.querySelector('.tab-content.redfin');
  },

  render: async function () {
    await BaseView.prototype.render.call(this);
    this.$headerLinks.filter('[data-key=redfin]').trigger('click');
    const searchContainer = this.el.querySelector('.search-container');

    if (searchContainer) {
      searchContainer.style.display = 'none';
    }
  },

  refresh: function () {
    this.$el.find('.items-content').find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
  },

  addOrderPrintLink: function () {
    const loginUrl = 'https://print.redfin.com';
    document.querySelector('header > div.options > .desygner-done-button').onclick = () => window.open(loginUrl);
    document.querySelector('header > .options > [data-action="order-print"]')?.remove?.();
  },

  initRedfinView: function () {
    this.registerTabView('redfin', new RedfinView({
      el: this.initTabView('redfin'),
      searchTerm: this.searchTerm,
      companyId: this.companyId
    }));
  },

  initTabView: function (type) {
    const $view = this.$el.find('.tab-content > .' + type);
    $view.html(template({
      type,
      isRedfin: type === 'redfin'
    }));

    return $view;
  }
});
